module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-main-f58219303bd9f5857f4162050768c85d.jpg";